import { render, staticRenderFns } from "./PopoverSpellingSuggestion.vue?vue&type=template&id=1897b360&scoped=true&"
import script from "./PopoverSpellingSuggestion.vue?vue&type=script&lang=js&"
export * from "./PopoverSpellingSuggestion.vue?vue&type=script&lang=js&"
import style0 from "./PopoverSpellingSuggestion.vue?vue&type=style&index=0&id=1897b360&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1897b360",
  null
  
)

export default component.exports